import { useContext } from 'react';
import { ServiceContext } from './context';

export default () => useContext(ServiceContext);
